var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22,
    fill: "url(#pattern0_6_82)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_82",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_82",
    transform: "matrix(0.0293333 0 0 0.0333333 -0.0133333 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_82",
    width: 35,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAYAAACmPacqAAAACXBIWXMAAAsTAAALEwEAmpwYAAACNElEQVRYhe3X2WsTURTH8U9qWq22VLQKrW3FIC4ItfVFEBHx31bEJ32pRfHFHbVal1YKdiF2iT6cGTJNJ8vEBH3wB5c7d3Jy852z3Dkpaa8RzCVzK63gKXY72DNXhzqwmcN4YttqjKKE1W5hyh3YjCbzItaa2JzCLM7hDbb7BVNK5iq2mth8QEWE8hI+FeRYx3Yp54MRXMbRzHoAm9hL7v3CMl5nvjeF+YIQqXbxKM8z8ziec/9Yw3pMeGo5WX/EMCbUvdmJhnAEZ/NgxpJ5UYQmT1OYwUV8Fp6CV8koogquYCgPJn2qNc1zZB1nRAinFaugmiYPWRbuPy/cldWseo7URJKuJOttvBdPdbUASKp1PNRQdWVcdzAfiHLNagIPsJGsX4gcGS8Ikp5J0+IY2AeTgjxpscEMTogceZzc28VCQRAiPyoiafcpmzNLLTbYwE1M4rko856rk0OPSOZVEZI7BX+jJsr/iXrV5WqgwKbPdOeRAXEUnG5n2KlniFDdx2BBmGsJSF6RdA2Taqegfa1TwyJh6rv+wzRTNznTK1WSkar6r3hmC2//pmeW8FLmLd4rmLJoPXYarltpR0OL0iuYW6IFuYfbyb531VsQuCByJD00DzTtvYIZFpVZxuHMdRZmMANSFW1qX2AWhGeqosUo42eDzTvxwqzhRwNoT2G+Zq6/NLHZxPdWm2RhbvwpUROlfwLbvtPKwnWTONknGCJ839oZlZIxLqcN7JH2RGPW9i/vb6qUa6bnoMpWAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.7aaad573634f19c435d463ea2d40203a.svg";
export { ForwardRef as ReactComponent };